import type { Audience } from '../core/store'
import { dictionaries, type Lang } from '../i18n'
import { esc, pad } from './dom'

/** Hero spec sheet (founded / base / languages / focus). */
export function renderProofs(el: HTMLElement | null, lang: Lang): void {
  if (!el) return
  el.innerHTML = dictionaries[lang].proofs
    .map(
      (p, i) => `<div class="spec__item" data-reveal style="--d:${520 + i * 70}ms">
        <dt class="mono">${esc(p.label)}</dt><dd data-scr>${esc(p.value)}</dd>
      </div>`,
    )
    .join('')
}

/** Capability ticker. Content is duplicated once so the CSS loop is seamless. */
export function renderMarquee(el: HTMLElement, lang: Lang): void {
  const items = dictionaries[lang].marquee
    .map((item) => `<span class="marquee__item">${esc(item)}</span><span class="marquee__sep">✦</span>`)
    .join('')
  el.innerHTML = `<div class="marquee__group">${items}</div><div class="marquee__group">${items}</div>`
}

export function renderServices(el: HTMLElement, lang: Lang, audience: Audience): void {
  const d = dictionaries[lang].services
  const blocks = audience === 'business' ? d.business : d.individuals
  el.innerHTML = blocks
    .map(
      (block, i) => `<article class="svc-card" data-reveal data-spotlight style="--d:${i * 110}ms">
        <span class="svc-card__big" aria-hidden="true">${pad(i + 1)}</span>
        <div class="svc-card__top mono">
          <span>${pad(i + 1)} / ${pad(blocks.length)}</span>
          <span class="svc-card__eyebrow" data-scr>${esc(block.eyebrow)}</span>
        </div>
        <h3 class="svc-card__title" data-scr>${esc(block.title)}</h3>
        <p class="svc-card__summary" data-scr>${esc(block.summary)}</p>
        <ul class="svc-card__list">
          ${block.bullets.map((b) => `<li><span class="plus" aria-hidden="true"></span><span data-scr>${esc(b)}</span></li>`).join('')}
        </ul>
        <div class="svc-card__focus">
          <p class="mono">${esc(d.focus)}</p>
          <ul class="chips">${block.focus.map((f) => `<li class="chip">${esc(f)}</li>`).join('')}</ul>
        </div>
      </article>`,
    )
    .join('')
}

export function renderSteps(el: HTMLElement, lang: Lang): void {
  const d = dictionaries[lang].process
  el.innerHTML = d.steps
    .map(
      (step, i) => `<li class="step" data-step="${i}">
        <p class="step__head mono"><span class="step__num">${pad(i + 1)}</span><span class="step__phase">${esc(d.phases[i] ?? '')}</span></p>
        <h3 class="step__title" data-scr>${esc(step)}</h3>
      </li>`,
    )
    .join('')
}

export function renderChecklist(el: HTMLElement, lang: Lang): void {
  el.innerHTML = dictionaries[lang].about.checklist
    .map((item, i) => `<li><span class="checklist__n mono">${pad(i + 1)}</span><span data-scr>${esc(item)}</span></li>`)
    .join('')
}
